import AuthenticatedUser from '../auth/AuthenticatedUser';
import Licenses from './Licenses';

// eslint-disable-next-line no-bitwise
export const hasLicense = (user: AuthenticatedUser, license: Licenses) => Boolean(((user.license ?? 0) & license) === license || ((user.effectiveLicense ?? 0) & license) === license);
export const containUserLicense = (user: AuthenticatedUser, licenses: Licenses[]) => {
  let index = 0;
  let result = false;
  while (index < licenses.length) {
    if (hasLicense(user, licenses[index])) {
      result = true;
      break;
    }
    index += 1;
  }
  return result;
};

export function licenseCheck<Return>(
  user: AuthenticatedUser,
  license: Licenses,
  // eslint-disable-next-line no-shadow
  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line no-shadow
  // eslint-disable-next-line no-unused-vars
  afterFn: ((...arg: any[]) => Return),
  ...args: any[]
): Return | undefined {
  if (hasLicense(user, license)) {
    return afterFn(...args);
  }

  return undefined;
}
